import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

interface GenerateSummaryResponse {
  ai_summary?: string
  suggested_tasks?: string[]
}

export function useGenerateCallSummary() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (callId: number) => {
      const { data } = await api.post<GenerateSummaryResponse>(
        `/api/calls/${callId}/generate-summary/`,
      )
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['call-logs'] })
    },
  })
}

export interface CallTranscription {
  transcript: string
  /** « Interlocuteur 1 : … », une réplique par ligne ; vide pour un appel IA. */
  transcript_by_speaker: string
  is_ai_call: boolean
}

/** La transcription d'un appel, pour le panneau « Détails » du fil. */
export function useCallTranscription(callId: number | null) {
  return useQuery({
    queryKey: ['call-transcription', callId],
    queryFn: async () => {
      const { data } = await api.get<CallTranscription>(`/api/calls/${callId}/transcription/`)
      return data
    },
    enabled: callId !== null,
    staleTime: 5 * 60 * 1000,
  })
}
